import { useEffect, useState } from "react";
import { tokens } from "../../global/theme/tokens";
import { API_GET, DBRequest, DBUploadData, useConfig } from "../../api/api";
import { useTheme, Box, Dialog, Typography, Button } from "@mui/material";
import SingleFileUpload from "../../components/upload/SingleFileUpload";
import Feedback from "../../components/special/Feedback";
import Loader from "../../components/special/Loader";
import ExoAvatar from "../../components/exo/ExoAvatar";
import DBSearch from "../../components/special/DBSearch";
import { useTranslation } from "react-i18next";
import SkeletonCard from "../../components/cards/SkeletonCard";

const UploadSigendOffer = ({ open, onClose }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: "info",
    alertText: "test",
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
    if (type === "success") {
      onClose();
      setOpenFileDrop(false);
    }
  }

  // offers
  const [offers, setOffers] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const config = useConfig();
  useEffect(() => {
    if (!open || !config) return;
    DBRequest({
      config,
      path: "offers?status[eq]=0",
      method: API_GET,
      onResponse: handleDataInit,
      onLoading: setIsLoading,
    });
  }, [open, config]);

  // selected
  const [openFileDrop, setOpenFileDrop] = useState(false);
  const [file, setFile] = useState({});
  const [selectedOfferId, setSelectedOfferId] = useState();
  const [percent, setPercent] = useState(0);
  const [isFinished, setIsFinished] = useState(true);
  const [reloading, setReloading] = useState(true);
  const [offersToDisplay, setOffersToDisplay] = useState([]);

  function handleSelect(offerId) {
    setSelectedOfferId(offerId);
    setOpenFileDrop(true);
  }

  function handleUpload() {
    setIsFinished(false);
    const formData = new FormData();
    console.log(file);
    if (Object.keys(file).length > 0) formData.append(`file`, file);

    DBUploadData({
      config,
      path: `offers/${selectedOfferId}/signedOffer`,
      formData,
      onProgressChange: setPercent,
      onFinished: setIsFinished,
      onFeedback: handleFeedbackSignedOffer,
    });
  }

  function handleFeedbackSignedOffer(response) {
    setIsFinished(true);
    console.log(response);
    if (response.status === 200) {
      window.location.reload(false);
      handleFeedback(response.response.data.message, "success");
    } else {
      handleFeedback(response.response.data.message, "error");
    }
  }

  function handleDataInit(data) {
    setOffers(data.data);
    setOffersToDisplay(data.data);
    setReloading(false);
  }

  function handleSearch() {}

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <Box
          className="p-4 w-full flex flex-col overflow-hidden"
          sx={{
            height: "90vh",
            width: "700px",
            maxWidth: "100%",
          }}
        >
          {reloading ? (
            <Box className="flex flex-col gap-2">
              <SkeletonCard height={46} />
              <SkeletonCard height={46} />
              <SkeletonCard height={46} />
              <SkeletonCard height={46} />
              <SkeletonCard height={46} />
            </Box>
          ) : (
            <>
              <Typography textAlign="center" variant="h2" className="pb-4">
                {t("Current Offers")}
              </Typography>
              <Box className="w-full flex flex-col h-full gap-4 overflow-hidden">
                {false && (
                  <DBSearch
                    onSearch={handleSearch}
                    param="offers?status[eq]=0"
                  />
                )}
                <Box className="overflow-y-auto flex flex-col gap-2 h-full">
                  {offersToDisplay.map((offer, index) => (
                    <Offer
                      key={"offerSing-" + index}
                      offer={offer}
                      onSelect={handleSelect}
                    />
                  ))}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Dialog>

      <Dialog open={openFileDrop}>
        <Box
          sx={{
            width: "calc(80vh / 1.412 )",
            maxWidth: "100%",
          }}
          className="flex flex-col overflow-hidden gap-2"
        >
          <Box className="p-4 flex  w-full h-full overflow-y-auto">
            <SingleFileUpload
              setFile={setFile}
              uploadedMedia={file}
              label={t("Upload Signed Offer")}
            />
          </Box>

          <Box className="flex flex-row justify-between pt-0 p-4">
            <Button onClick={() => setOpenFileDrop(false)}>
              {t("Cancle")}
            </Button>
            <Button
              onClick={handleUpload}
              disabled={!Object.keys(file).length}
              variant="contained"
            >
              {t("Upload")}
            </Button>
          </Box>
          <Loader active={!isFinished} />
        </Box>
      </Dialog>

      <Feedback setState={setAlertState} state={alertState} />
    </>
  );
};

const Offer = ({ offer, onSelect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  var name = "";
  if (offer.recipientType === "company") name = offer.recipient.name;
  if (offer.recipientType === "contact")
    name = offer.recipient.firstName + " " + offer.recipient.lastName;
  return (
    <Box
      className="flex flex-row justify-start items-center gap-4 w-full rounded-lg p-2 cursor-pointer"
      sx={{
        backgroundColor: colors.glass,
      }}
      onClick={() => onSelect(offer.id)}
    >
      <Box className="monospace">{offer.nr}</Box>
      <ExoAvatar
        picture={offer.recipient.logo && offer.recipient.logo.temporaryUrl}
        type={offer.recipientType}
        name={name}
        size="30px"
      />
      <Typography variant="h4">{offer.title}</Typography>
    </Box>
  );
};

export default UploadSigendOffer;
